import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import Confirm, {deleteProps} from '../../form/Confirm'
import Button from "../../form/Button";
import TextInput from "../../form/TextInput";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import DateTimeInput from "../../form/DateTimeInput";

class SelectType extends React.Component {
    render() {
        let options = this.props.values.type_config?.options || [];
        return (
            <div className="row form-row">
                <div className="col-md-12">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-8"><label className="control-label">Opciók</label></div>
                            <div className="col-sm-3"><label className="control-label">Ár</label></div>
                            <div className="col-sm-1"><label className="control-label">Törlés</label></div>
                        </div>
                        {options.map((option, idx) => {
                            return(
                                <div key={idx} className="row form-row">
                                    <div className="col-sm-8">
                                        <TextInput
                                            label={false}
                                            name={"type_config.options." + idx + ".value"}
                                            value={option.value}
                                            saveChanges={this.props.setFieldValue}
                                        />
                                    </div>
                                    <div  className="col-sm-3 unit">
                                        <TextInput
                                            name={"type_config.options." + idx + ".listprice"}
                                            label={false}
                                            value={option.listprice}
                                            formatter={CurrencyFormatter}
                                            saveChanges={this.props.setFieldValue}
                                        />
                                    </div>
                                    <div  className="col-sm-1">
                                        <Confirm
                                            {...deleteProps}
                                            onAccept={() => {
                                                let newOptions = [...options];
                                                newOptions.splice(idx, 1);
                                                this.props.setFieldValue("type_config.options", newOptions);
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                        <div className="row form-row">
                            <div className="col-md-12">
                                <Button
                                    block={true}
                                    color="default"
                                    icon={{lib: "fa", name: "plus"}}
                                    onClick={() => {
                                        this.props.setFieldValue("type_config.options", [...options, {value: null, listprice: 0}]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// class FileInputType extends React.Component {
//     render() {
//         let options = this.props.values.type_config || {};
//         return (
//             <div className="row form-row">
//                 <div className="col-md-6">
//                     <TextInput
//                         label="Maximum darab"
//                         type="number"
//                         name={"type_config.limit"}
//                         value={type_config.limit}
//                         saveChanges={this.props.setFieldValue}
//                     />
//                 </div>
//                 <div className="col-md-6">
//                     <TextInput
//                         label="Fájl típusok"
//                         name={"type_config.accept"}
//                         value={type_config.accept}
//                         placeholder="Pl.: *.pdf,*.doc,*.docx"
//                         saveChanges={this.props.setFieldValue}
//                     />
//                 </div>
//             </div>
//         );
//     }
// }

class ProgramOptionForm extends React.Component {

    render() {

        let TypeEditor = null;
        switch (this.props.values.type_value + "") {
            case "1":
            case "2":
                TypeEditor = SelectType;
                break;
            case "6":
                TypeEditor = FileInputType;
                break;
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2 col-sm-push-10">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-4 col-sm-pull-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="title"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-sm-3 col-sm-pull-2">
                        <Select
                            name="program_type"
                            optionname="ProgramOptionType"
                            objectValue={false}
                            storeType="local"
                            label="Program típusa"
                            value={this.props.values.program_type}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3 col-sm-pull-2">
                        <Select
                            name="type_value"
                            optionname="PollType"
                            objectValue={false}
                            storeType="local"
                            label="Választó típusa"
                            value={this.props.values.type_value}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                {TypeEditor && <TypeEditor {...this.props} />}
            </form>
        );
    }
}

export default createForm(ProgramOptionForm);
